import { JsonObject } from './types';

export default class Constants {
  static readonly ERROR_TYPE: JsonObject = {
    UNAUTHORIZED: 'Unauthorized',
    FORBIDDEN: 'Forbidden',
    BAD_REQUEST: 'BadRequest',
  };
}
